<div tabindex="0" class="checkout mt-5 mb-5">
    <div class="card col-md-8 offset-md-2 col-xl-6 offset-xl-3 mb-4">
        <div class="row">
            <div class="card-header px-5">
                <h2>
                    <span [appTranslate]="'ThankYouForRegistering'" role="alert">Thank you for registering for the event!</span></h2>
                <p [appTranslate]="'EmailInfo'" >For confirmation you will receive an email soon!</p>
            </div>
        </div>
    </div>
</div>
